import { render, staticRenderFns } from "./SystemView.vue?vue&type=template&id=4e6fb97e&scoped=true"
import script from "./SystemView.vue?vue&type=script&lang=js"
export * from "./SystemView.vue?vue&type=script&lang=js"
import style0 from "./SystemView.vue?vue&type=style&index=0&id=4e6fb97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6fb97e",
  null
  
)

export default component.exports